import { getObjects, createObject, updateObject, deleteObject, exportUsers, exportObjects, exportFile_Bilan, broadcast } from "../../../services/services";
import Conditions from "../../../assets/files/conditions.json";

const combboxGroups = [
  "s","d"
];
const IS_SUPER_USER_OPTIONS = [
  { label: "true", value: "true" },
  { label: "false", value: "false" },
];

export const usersConfig = {
  title: "Users",
  entityLabel: "User",

  idField: "id",

  rowActions: [
    { key: "info", label: "Info", permission: "view_profile", action: "info" },
    { key: "edit", label: "Edit", permission: "edit_users", action: "edit" },
    { key: "delete", label: "Delete", permission: "delete_users", action: "delete" }
  ],

  actionHandlers: {
    info: ({ entity, setState, setFormParams }) => {
    setState("info");
    entity['is_superuser'] = String(entity['is_superuser']);
      
    setFormParams([entity]);
    },
    edit: ({ entity, setState, setFormParams }) => {
      entity['is_superuser'] = String(entity['is_superuser']);
      setState("edit");
      setFormParams([entity]);
    },
    delete: async ({ entity, setEntityToDelete }) => {
      setEntityToDelete(entity);
    },
  },
  
  services: {
    list: getObjects,
    create: createObject,
    update: updateObject,
    delete: deleteObject,
    export: exportObjects,
    export_bilan: exportFile_Bilan,
    filters: "show",
    columns: "show",

    services_url_names: {
    list: "getAllUsers",
    create: "createUser",
    update: "updateUser",
    delete: "deleteUser",
    export: "exportUsers",
    export_bilan: "exportUsers_Bilan"
    },
  },

  attributes: [
    { label: "profile_picture", value: "profile_picture", type: "str" },
    { label: "id", value: "id", type: "int", is_default:"true" },
    { label: "username", value: "username", type: "str", is_default:"true" },
    { label: "email", value: "email", type: "str", is_default:"true" },
    { label: "created_at", value: "created_at", type: "date" },
    { label: "updated_at", value: "updated_at", type: "date" }, 
    { label: "last_login", value: "last_login", type: "date" },
    { label: "groups", value: "groups", type: "str"},
    { label: "is_superuser", value: "is_superuser",
      type: "proposition", "select":[
      "true",
      "false"
    ]},
  ],
  conditions: Conditions,

  formFields: [
    {key: "username", label: "Full Name", type: "input", validation: ["required"] },
    {key: "email", label: "Email", type: "email", validation: ["required", "email"] },
    {key: "is_superuser", label: "is_superuser", type: "select", SELECT_OPTIONS:IS_SUPER_USER_OPTIONS, validation: ["required"] },
    {key: "password", label: "password", type: "password", validation: ["required"] ,  state: ["create"]},
    {key: "confirm password", label: "confirm password", type: "password", validation: ["required"] ,  state: ["create"]},
    {key: "groups", label: "groups", type: "MultiSelectAutocomplete", MultiSelectAutocomplete:combboxGroups, validation: ["required"] },
    
  ],

   defaultFilters : [],


  // =========================
  // TABS CONFIG (CUSTOM PER ENTITY)
  // =========================
  tabs: [
    {
      label: "All",
      filters: [],   // tabIndex 0
    },
  ],
};
